import React, { Component } from 'react'
import './index.less'
import { inject, observer } from 'src/core/store'
import { setDocumentTitle, setUidToken, InitPage } from 'src/helper/tool'
import langM from './lang'
import { getlang, setlang } from 'src/helper/getlang'
import moment from "moment"
import http from 'src/helper/http'
import MobileTable from '@yrobot/react-mobile-table';
import '@yrobot/react-mobile-table/lib/index.css';
import ReminderBtn from 'src/component/RuleButton'
import Message from 'src/component/Message'
import { Table, } from 'antd';
import 'antd/dist/antd.css';
const GOLD_TYPE = [
  'unknown',
  'Send Gift',
  'Exchange diamond',
  'Buy Head',
  'the finger-guessing game',
  'Buy mount',
  'checkin',
  'Weekly reward',
  'Agent recharge',
  'Custom background',
  'Custom background return',
  'Fruit game bet',
  'Fruit game win',
  'Buy noble',
  'App recharge',
  'Administrator action',
  'Every day to noble',
  'Service account reward',
  'CP love icon',
  'CP reward',
  'user share reward',
  'room reward',
  'system presents gold coins',
  'crystal explosion reward',
  'fruit reward',
  'recharge reward',
  'pay for lottery',
  'lottery reward',
  'Eid al-Adha reward',
  'Mine Game Return',
  'Mine Game Reward',
  'Mine Game',
  'Room Support Reward',
  'Mini Game Coins',
  "Queen 's reward",
  'Fruit Support Reward',
  'Paymax agent',
  'Create PK',
  'PK Return',
  'National Day Reward',
  'PK Reward',
  'National Star Reward',
  'PK Activity Reward',
  'wheel game bet',
  'Win wheel games',
  'FIFA',
  'Ludo Game',
]
@inject('store')
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.ruby = this.props.store.register('app/ruby')
  }

  state = {
    lang: langM.ar,
    language: 'en',
    userInfo: {},
    recordOrSourceCon: 1,
    goldOrRubyCon: 1,
    scroll: '0:20',
    dataType: 0,
    dataList: [['Uid', 'Number', 'Describe', 'Time']],
    hasMore: false,
    dataListCuoms:[
      {
        title: 'Uid',
        dataIndex: 'uid',
        key: 'uid',
        render: text => <div style={{minWidth:'1.6rem'}}>{text}</div>,
      },
      {
        title: 'Number',
        dataIndex: 'number',
        key: 'number',
        
      },
      {
        title: 'Type',
        dataIndex: 'rType',
        key: 'type',
      },
      {
        title: 'Describe',
        key: 'describe',
        dataIndex: 'describe',
      },
      {
        title: 'Time',
        key: 'time',
        dataIndex: 'ts',
        render: text => <div style={{minWidth:'1.6rem'}}>{moment(text * 1000).format('YYYY-MM-DD HH:mm:ss')}</div>,
      },
    ]
  }

  async componentWillMount() {
    let { language } = this.props.location.query
    language =await getlang(language)
    console.log('language', language)

    // lang 文字对象
    // language 语言种类 (zh/ar/en)
    this.setState({
      lang: setlang(language, langM),
      language: language
    })
    let uid = await setUidToken(this.props.location.query)
    console.log('admin-control-user', this.props.location.query)
    this.setState({
      uid: uid,
      fiduid: this.props.location.query.finduid * 1,
    })

    // console.log(uid, 'uid')
    await this.getUserInfo(this.props.location.query.finduid)
    await this.getDataList()
  }

  // 初始化/接口请求初始化

  getUserInfo = async (uid) => {
    let res = await http.post('/web/user/info', { uidDuid: uid + '' })
    console.log(res)
    if (res.code == 0) {
      this.setState({ userInfo: res.res })
    }
  }
  getDataList = async () => {
    let { fiduid, scroll, dataType, dataList, recordOrSourceCon } = this.state
    let url = recordOrSourceCon == 1 ? 'web/gold/record' : '/web/gold/source'
    let res = await http.post(url, {
      uid: fiduid,
      scroll,
      type: dataType
    })

    if (res.code == 0) {
      let recordColumns = [
        {
          title: 'Uid',
          dataIndex: 'uid',
          key: 'uid',
         
        },
        {
          title: 'Number',
          dataIndex: 'number',
          key: 'number',
        },
        {
          title: 'Type',
          dataIndex: 'rType',
          key: 'type',
          render: text => <div>{GOLD_TYPE[text] || '--'}</div>,
        },
        {
          title: 'Describe',
          key: 'describe',
          dataIndex: 'describe',
        },
        {
          title: 'Time',
          key: 'time',
          dataIndex: 'ts',
          render: text => <div>{moment(text * 1000).format('YYYY-MM-DD HH:mm:ss')}</div>,
        },
      ];
      let sourceColumns = [
        {
          title: 'Number',
          dataIndex: 'number',
          key: '9',
         
        },
        {
          title: 'Describe',
          key: '10',
          dataIndex: 'describe',
        },
      ];
      let dataListCuoms = recordOrSourceCon == 1 ? recordColumns : sourceColumns
      let arr = []
      if (recordOrSourceCon == 1) {
        arr = res.res.list
      } else {
        
        arr = res.res
        return this.setState({
          dataList: arr && arr.length > 0 && [ ...arr],
          hasMore: false,
          scroll: '0:20',
          dataListCuoms
        })
      }

      this.setState({
        dataList: arr && arr.length > 0 && [ ...arr],
        hasMore: res.res.hasMore,
        scroll: res.res.scroll,
        dataListCuoms
      })
    }
  }
  addMroe = async () => {
    let { fiduid, scroll, dataType, dataList } = this.state
    let res = await http.post('web/gold/record', {
      uid: fiduid,
      scroll,
      type: dataType
    })
    if (res.code == 0 && res.res.list.length) {
      let arr = res.res.list
      this.setState({
        dataList: arr && arr.length > 0 && [...dataList, ...arr],
        hasMore: res.res.hasMore,
        scroll: res.res.scroll
      })
    }
  }
  recordOrSource = async (e) => {
    await this.setState({ recordOrSourceCon: e, scroll: '0:20' })
    await this.getDataList()
  }
  goldOrRuby = async (e) => {
    await this.setState({ goldOrRubyCon: e, dataType: e == 1 ? 0 : 1, scroll: '0:20' })
    await this.getDataList()
  }
  render() {
    let { lang, userInfo, recordOrSourceCon, goldOrRubyCon, dataList, hasMore, dataListCuoms } = this.state
    return (
      <div className="bane-reset-userdata">
        <div className="user-card">
          <div className="set-user-info">
            <div className="avatar-root">
              <img className="avatar-img" src={userInfo.avatarurl}></img>
            </div>
            <div className="user-info">
              <div className="user-info-top">
                <div className="top-text">{userInfo.nickname}</div>
              </div>
              <div className="user-info-top">
                <div className="top-text">{userInfo.bio}</div>
              </div>
              <div className="user-info-buttom">ID: {userInfo.uid}</div>
            </div>
          </div>
        </div>
        {/* <div className="ban-reset">{lang.totalRe}：$ {(userInfo.totalRecharge || 0) / 100}</div> */}
        <div className="record-source">
          <div className={`record ${recordOrSourceCon == 1 ? 'atv-record-source' : ''}`} onClick={() => this.recordOrSource(1)}>{lang.recordText}</div>
          <div className={`source ${recordOrSourceCon == 2 ? 'atv-record-source' : ''}`} onClick={() => this.recordOrSource(2)}>{lang.source}</div>
        </div>
        <div className="gold-ruby">
          <div className={`gold ${goldOrRubyCon == 1 ? 'atv-gold-ruby' : ''}`} onClick={() => this.goldOrRuby(1)}>{lang.coin}</div>
          <div className={`ruby ${goldOrRubyCon == 2 ? 'atv-gold-ruby' : ''}`} onClick={() => this.goldOrRuby(2)}>{lang.ruby}</div>
        </div>
     {/*    <div className={`${recordOrSourceCon == 2 ? 'dsada' : 'on-record'}`}>
          {recordOrSourceCon == 6 && <MobileTable
            data={dataList} // 数据源:[[]]
            columnMinWidth={300} // 每一列的最小宽度, 假设屏宽为375, 默认值60: Int
            // table内部点击事件回调
            onClick={(param) => {
              const {
                column, //第几列，从0开始
                line, // 第几行，从0开始，包含header行
                collapse, // 当前列是否折叠,boolean
                event,
              } = param;
              console.log(param);
            }}
          />}
          {recordOrSourceCon == 3 && <MobileTable

            data={dataList} // 数据源:[[]]
            columnMinWidth={375} // 每一列的最小宽度, 假设屏宽为375, 默认值60: Int
            // table内部点击事件回调
            onClick={(param) => {
              const {
                column, //第几列，从0开始
                line, // 第几行，从0开始，包含header行
                collapse, // 当前列是否折叠,boolean
                event,
              } = param;
              console.log(param);
            }}
          />}
        </div> */}
        <Table columns={dataListCuoms} dataSource={dataList} pagination={false} scroll={{ x: 'max-content' }} autoWidth={true} ></Table>
        {hasMore && <div onClick={this.addMroe} className='more'> More</div>}
        <Message ref="msg" desc={this.state.desc} />
      </div>
    )
  }
}




// WEBPACK FOOTER //
// src/pages/admin-control/bane-reset-userdata/index.js